import { Box, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { SortDescIcon } from '~/assets/icons';
import { memo } from 'react';
import { SortDirection } from '~/utils/types/job';
import { HeadCelType } from '~/utils/types/common';
import { SortDirectionEnum } from '~/utils/enum';

export type BaseTableHeadProps = {
  headCells: Array<HeadCelType>;
  sortBy?: string;
  sortOrder?: SortDirection;
  onRequestSort: (property: string, sortDirection: SortDirection) => void;
};

export const BaseTableHeadRowReport = memo(function BaseTableHeadRowReport(props: BaseTableHeadProps) {
  const { headCells, sortBy, sortOrder, onRequestSort }: BaseTableHeadProps = props;

  const createSortHandler = (property: string) => () => {
    let direction: SortDirection;

    if (sortBy === property) {
      direction = sortOrder === SortDirectionEnum.ASC ? SortDirectionEnum.DESC : SortDirectionEnum.ASC;
    } else {
      direction = SortDirectionEnum.ASC;
    }

    onRequestSort(property, direction);
  };

  return (
    <TableRow>
      {headCells.map((headCell: HeadCelType, index: number) => (
        <TableCell
          key={`${headCell.id as string}-${index}`}
          variant='head'
          className={`cursor-pointer ${headCell.className}`}
        >
          <Box className='flex justify-center items-center min-w-0 max-w-full'>
            <Typography className='text-sm font-semibold text-[#161A1F] whitespace-nowrap overflow-hidden text-ellipsis min-w-0'>
              {headCell.label ?? headCell.id}
            </Typography>
            {headCell.sortable && (
              <SortDescIcon
                onClick={(e) => {
                  e.stopPropagation();
                  createSortHandler(headCell.id)();
                }}
                className={`w-5 h-5 ml-2 shrink-0 cursor-pointer transition-transform duration-200 ease-out ${
                  sortBy === headCell.id ? 'text-[#123B6D]' : 'opacity-40'
                } ${sortBy === headCell.id && sortOrder === SortDirectionEnum.ASC ? 'rotate-180' : ''}`}
              />
            )}
          </Box>
        </TableCell>
      ))}
    </TableRow>
  );
});

const BaseTableHeadReport = (props: BaseTableHeadProps) => {
  return (
    <TableHead>
      <BaseTableHeadRowReport {...props} />
    </TableHead>
  );
};

export default memo(BaseTableHeadReport);
